import styled from "styled-components";

export const FirstScreenWrapper = styled.div`
  margin: 50px 0;
  width: 100%;
`;

export const FirstScreenMain = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 991.98px) {
    flex-direction: column-reverse;
  }
`;

export const FirstScreenLeft = styled.div`
  width: 50%;
  padding: 0 20px;
  @media (max-width: 991.98px) {
    width: 100%;
  }
  & h1 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 83px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    @media (max-width: 1199.98px) {
      font-size: 62px;
    }
    @media (max-width: 768px) {
      font-size: 48px;
    }
    @media (max-width: 477.98px) {
      font-size: 38px;
    }
    & span {
      font-family: "Poppins";
      font-style: italic;
      font-weight: 900;
    }
  }
  & h5 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    margin: 40px 0;
  }
  & button {
    border: 1px solid ${(props) => props.theme.borderColor};
    border-radius: 36px;
    width: 150px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    background: ${(props) => props.theme.bgColor};
    cursor: pointer;
    transition: 0.2s;
    &:hover {
      color: #0088cc;
      border: 1px solid #0088cc;
    }
  }
`;

export const FirstScreenRight = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  @media (max-width: 991.98px) {
    width: 100%;
    margin-bottom: 40px;
  }
`;
